import _classCallCheck from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Range = function Range(x, y) {
  _classCallCheck(this, Range);

  this.position = {
    x: x,
    y: y
  };
};